<script setup lang="ts">
/**
 * Fixed strip marking an environment as demo data.
 *
 * Deliberately unmissable and not dismissible: these apps show seeded
 * workers, payouts and identity documents, and someone landing on a shared
 * link must not mistake any of it for live records.
 */
withDefaults(defineProps<{ label?: string }>(), { label: 'Demo data — not a live system' })
</script>

<template>
  <div class="k-demo" role="note">
    <span class="k-demo__dot" aria-hidden="true" />
    <span>{{ label }}</span>
    <slot />
  </div>
</template>

<style scoped>
.k-demo {
  position: fixed; top: 0; left: 0; right: 0; z-index: var(--k-z-toast);
  display: flex; align-items: center; justify-content: center; gap: var(--k-space-2);
  padding: var(--k-space-1) var(--k-space-4);
  background: var(--k-color-warning-tint); color: var(--k-color-warning);
  border-bottom: 1px solid var(--k-color-warning);
  font-size: var(--k-font-size-xs); line-height: var(--k-line-height-md);
  font-weight: var(--k-font-weight-medium);
  text-align: center;
}
.k-demo__dot {
  width: 6px; height: 6px; border-radius: var(--k-radius-circle);
  background: currentColor; flex: none;
}
</style>
